<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Making Teca', route: '/backoffice/making-teca/' }, { label: 'Aggiungi Making Teca', route: '/backoffice/making-teca/add' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">AGGIUNGI MAKING TECA POST</h1>
</section>


<section class="pb-16 mb-8 px-container">
    <form [formGroup]="formPost" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/2 w-full">
                    <label>* Titolo</label>
                    <input type="text" pInputText placeholder="Titolo" formControlName="titolo" required />
                    <small class="text-red-600 block mt-4 font-medium" *ngIf="formPost.get('titolo')?.hasError('required') && (formPost.get('titolo')?.dirty || formPost.get('titolo')?.touched)">Il titolo è obbligatorio!.</small>
                </div>
                <div class="lg:w-1/2 w-full">
                    <label>* Data</label>
                    <br />
                    <p-calendar formControlName="data" class="w-full grid" dateFormat="dd/mm/yy" [showIcon]="true" />
                    <small class="text-red-600 block mt-4 font-medium" *ngIf="formPost.get('data')?.hasError('required') && (formPost.get('data')?.dirty || formPost.get('data')?.touched)">La data è obbligatoria!.</small>
                </div>
            </div>
            <div class="w-full">
                <label>* Immagine Box</label>
                <p-fileUpload mode="advanced" [multiple]="false" chooseLabel="Seleziona un'immagine" accept="image/*" maxFileSize="1000000000" cancelLabel="Rimuovi" [showUploadButton]="false" (onSelect)="onImmagineUpload($event)" (onRemove)="onRemoveImmagineUpload($event)" (onClear)="onRemoveImmagineUpload($event)" />
            </div>
        </div>

        <div class="flex flex-col gap-8 mt-16">
            <div class="w-full">
                <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">AGGIUNGI UN CONTENUTO AL POST <i class="text-base">(opzionale)</i></h1>
            </div>
            <ng-container *ngFor="let contenuto of post_data; let i = index">
                <div class="w-full">
                    <label>* Titolo</label>
                    <input type="text" pInputText placeholder="Titolo" [formControlName]="'titolo_' + i" />
                </div>
                <div class="w-full">
                    <label>Descrizione</label>
                    <p-editor [style]="{ height: '150px' }" [formControlName]="'descrizione_' + i" />
                </div>
                <div class="w-full">
                    <label>* Immagine Contenuto</label>
                    <p-fileUpload mode="advanced" [multiple]="false" chooseLabel="Seleziona un'immagine" accept="image/*" maxFileSize="1000000000" cancelLabel="Rimuovi" [showUploadButton]="false" (onSelect)="onImmagineContenutoUpload($event, i)" (onRemove)="onRemoveImmagineContenutoUpload($event, i)" (onClear)="onRemoveImmagineContenutoUpload($event, i)" />
                </div>
                <div class="flex lg:flex-row flex-col-reverse gap-8 items-center">
                    <div class="lg:w-1/2 w-full"></div>
                    <div class="lg:w-1/2 w-full text-end">
                        <button class="btn-danger-backoffice p-3 lg:w-1/2 w-full font-medium" type="button" (click)="onRemoveContenuto(i)" [disabled]="post_data.length == 1">Rimuovi contenuto</button>
                    </div>
                </div>                      
                <hr *ngIf="post_data.length > 1">
            </ng-container>
        </div>

        <hr class="mt-8">

        <div class="flex lg:flex-row flex-col gap-8">
            <div class="lg:w-1/2 w-full">
                <button class="btn-outln-backoffice p-3 w-full font-medium mt-8 mb-8" type="button" (click)="onAddContenuto()">Aggiungi un Contenuto</button>
            </div>
            <div class="lg:w-1/2 w-full">
                <button class="btn-outln-backoffice p-3 w-full font-medium mt-8" type="submit" [disabled]="!formPost.valid">Aggiungi Post</button>                    
            </div>
        </div>
        
    </form>
</section>